module.exports = "<div class=\"input-rupee\">\n  <span [ngClass]=\"{'rupee-img-span':true, 'blue':isBlue}\"><img class=\"\" src=\"../../../../../assets/icons/Rupee icon.png\"></span>\n  <input type=\"text\" [id]=\"id\"[placeholder]=\"placeholder\" [ngClass]=\"{'rupee-class':true, 'blue':isBlue}\" name=\"rupee-input\" [(ngModel)]=\"value\" #rupeeinput (input)=\"updateValue(rupeeinput.value)\"  (keypress)=\"keyPress($event)\" maxlength=\"12\"  [disabled]=\"disabled\" >\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/input-rupee/input-rupee.component.html
// module id = ./src/app/modules/shared/components/input-rupee/input-rupee.component.html
// module chunks = main